/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  container: {
    maxWidth: '750px',
  },
  bannerArea: {
    display: 'grid',
    alignItems: 'start',
    textAlign: 'center',
    '& img': { maxWidth: '100%' },
    '& $textHolder': {
      fontSize: '12px',
      color: '#565960',
      marginBottom: '25px',
      marginTop: '25px',
      '& h1': {
        fontWeight: '600',
        marginBottom: '12px',
        fontSize: '14px',
      },
      '& $textHolderSuccess': {
        color: theme.palette.primary.successGreen,
      },
      '& $textHolderTerminate': {
        color: theme.palette.primary.main,
      },
      '& $textHolderReject': {
        color: theme.palette.primary.warningMango,
      },
      '& p': {
        fontSize: '12px',
      },
    },
  },
  textDownload: {
    color: '#342D3D',
    fontWeight: '600',
    display: 'inline-block',
    border: '1px solid #342D3D',
    borderRadius: '10px',
    textAlign: 'center',
    padding: '11px 10px',
    width: '100%',
    textTransform: 'none',
    '& img': {
      marginRight: '8px',
    },
  },
  textHolderSuccess: {},
  textHolderReject: {},
  textHolderTerminate: {},
  strongText: {
    fontWeight: '600',
  },
  marginTop: { marginTop: '15px', paddingRight: '15px' },
  totalAmount: {
    color: theme.palette.primary.main,
  },
  detailItem: {
    borderBottom: '1.46951px solid #EBEEF3',
    padding: '15px',
    display: 'flex',
    // justifyContent: 'space-between',
    flexDirection: 'column',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
  },
  detailItemHorizontal: {
    borderBottom: '1.46951px solid #EBEEF3',
    padding: '15px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  itemRight: {
    justifyContent: 'flex-end',
  },
  textHolder: {},
  darkgray: {
    color: '#fff',
    background: '#565960',
  },
  gotoproBtn: {
    display: 'block',
    height: '60px',
    background: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '10px',
    fontWeight: '600',
    fontSize: '16px',
    width: '100%',
    textTransform: 'none',
    '&:hover': {
      background: '#bb3147',
    },
  },
  footerBtnHolder: {
    paddingTop: '32px',
    // borderTop: '1.46951px solid #EBEEF3',
  },
  downloadActionsWrapper: {
    display: 'grid',
    gridGap: 10,
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '2fr 2fr',
    },
  },
  darkgreen: {
    color: '#fff',
    background: '#1C999B',
  },
  '@media (min-width: 768px)': {
    bannerArea: {
      gridTemplateColumns: '176px auto',
      textAlign: 'left',
      gap: '17px',
      '& $textHolder': {
        fontSize: '14px',
        '& h1': {
          fontSize: '20px',
        },
        '& p': {
          fontSize: '14px',
        },
      },
    },
  },
  '@media (min-width: 992px)': {
    contentArea: {
      padding: '60px 0',
    },
  },
  '@media (max-width: 767px)': {
    footerBtnHolder: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      background: '#fff',
      padding: '16px',
      borderTop: '3px solid #EBEEF3',
      zIndex: '1021',
      '& button': {
        borderRadius: '10px',
        padding: '0.65em 3em',
        height: 'auto',
        fontSize: '14px',
      },
    },
    textDownload: {
      display: 'block',
      width: '100%',
      border: '1px solid #342D3D',
      borderRadius: '10px',
      textAlign: 'center',
      padding: '11px 10px',
    },
  },
});

export default styles;
